<template>
    <!-- 注释卡片：类型 / 名称 / 所属工程 → 概述与操作 → 场景 / 参数 / 限制 / 关键字 -->
    <div class="jdoc-card" :class="{ 'is-deprecated': dataObj.isDeprecated }">
        <div class="jdoc-card__head">
            <span class="jdoc-card__kind" :class="dataObj.metaType == 'JavaDocClass' ? 'is-class' : 'is-method'">
                {{ dataObj.metaType == 'JavaDocClass' ? '类' : '方法' }}
            </span>
            <div class="jdoc-card__title">
                <el-tag v-if="dataObj.isDeprecated" type="danger" size="small" effect="light" class="jdoc-card__tag">废弃</el-tag>
                <el-tag v-if="dataObj.qualifier" :type="dataObj._isPublic ? 'success' : 'info'" size="small" effect="light" class="jdoc-card__tag">{{ dataObj.qualifier }}</el-tag>

                <span v-if="dataObj.className" class="jdoc-card__class" :class="{ 'is-clickable': dataObj.javaDocClassLite }" @click="showDialog('classDetailsDialog')">{{ dataObj.className }}</span>
                <span v-if="dataObj.className" class="jdoc-card__dot">.</span>
                <span class="jdoc-card__name">{{ dataObj.name }}</span>

                <el-tooltip placement="top" effect="light" content="复制名称">
                    <el-icon class="jdoc-card__copy" @click="copy(dataObj.className ? dataObj.className + '.' + dataObj.name : dataObj.name)">
                        <CopyDocument />
                    </el-icon>
                </el-tooltip>

                <el-tooltip v-if="!dataObj.isDeprecated" placement="top" effect="light">
                    <template #content>
                        <span v-if="isLogin">
                            <span style="line-height: 34px">推荐：</span>
                            <el-rate v-model="helpfulRate" @change="helpful" />
                        </span>
                        <span v-else>登录后可推荐</span>
                    </template>
                    <el-rate class="jdoc-card__rate" v-model="dataObj.helpfulRate" disabled />
                </el-tooltip>
            </div>
            <span class="jdoc-card__project" v-html="dataObj.projectName"></span>
        </div>

        <div class="jdoc-card__brief">
            <div class="jdoc-card__info" v-html="dataObj.commentInfo"></div>
            <div class="jdoc-card__acts">
                <el-button v-if="dataObj.commentExample" type="primary" size="small" plain round @click="showDialog('commentExampleDialog')">示例</el-button>
                <el-popover v-if="dataObj.metaType == 'JavaDocClass' && dataObj.commentLog && dataObj.commentLog.length > 0" placement="left-end" :width="800" trigger="click">
                    <template #reference>
                        <el-button type="warning" size="small" plain round>日志</el-button>
                    </template>
                    <div class="jdoc-card__log">
                        <el-table :data="dataObj.commentLog" :default-sort="{ prop: 'version', order: 'descending' }" height="400" border stripe>
                            <el-table-column prop="version" label="版本" sortable width="140" />
                            <el-table-column prop="time" label="修改时间" sortable width="140" />
                            <el-table-column prop="author" label="修改人" width="120" />
                            <el-table-column prop="content" label="修改内容" />
                        </el-table>
                    </div>
                </el-popover>
                <el-button v-if="isLogin" type="danger" size="small" plain round @click="showDialog(dataObj.metaType == 'JavaDocClass' ? 'originDocumentDialog' : 'sourceCodeDialog')">Code</el-button>
            </div>
        </div>

        <div v-if="dataObj.commentScene" class="jdoc-card__line jdoc-card__line--scene">
            <span class="jdoc-card__emoji">🎬️</span>
            <span class="jdoc-card__strong">场景：</span>
            <span v-html="dataObj.commentScene"></span>
        </div>

        <div v-if="dataObj.metaType == 'JavaDocMethod'" class="jdoc-card__io">
            <div class="jdoc-card__iobox">
                <div class="jdoc-card__iocap">传入参数</div>
                <p v-for="(item, i) in dataObj.params" :key="'param' + i" class="jdoc-card__iorow">
                    <span class="jdoc-card__emoji">➡️</span>
                    <el-text type="primary">{{ item.type }}</el-text>
                    <span class="jdoc-card__colon">:</span>
                    <el-text type="warning">{{ item.desc }}</el-text>
                </p>
                <p v-if="!dataObj.params.length" class="jdoc-card__iorow">
                    <span class="jdoc-card__emoji">➡️</span>
                    <el-text type="info">没有入参</el-text>
                </p>
            </div>
            <div class="jdoc-card__iobox">
                <div class="jdoc-card__iocap">返回值 / 异常</div>
                <p class="jdoc-card__iorow">
                    <span class="jdoc-card__emoji">↩️</span>
                    <el-text type="primary">{{ dataObj.returnType }}</el-text>
                    <span class="jdoc-card__colon">:</span>
                    <el-text :type="dataObj.returnType == 'void' ? 'info' : 'warning'">{{ dataObj.returnType == 'void' ? '没有返回值' : dataObj.returnDesc }}</el-text>
                </p>
                <p v-for="(item, i) in dataObj.throwses" :key="'throws' + i" class="jdoc-card__iorow">
                    <span class="jdoc-card__emoji">🐞</span>
                    <el-text type="primary">{{ item.type }}</el-text>
                    <span class="jdoc-card__colon">:</span>
                    <el-text type="warning">{{ item.desc }}</el-text>
                </p>
            </div>
        </div>

        <div v-if="dataObj.commentLimit" class="jdoc-card__line jdoc-card__line--limit">
            <span class="jdoc-card__emoji">⛔️</span>
            <span class="jdoc-card__strong">限制：</span>
            <span v-html="dataObj.commentLimit"></span>
        </div>

        <!-- 关键字 -->
        <div v-if="dataObj._commentKeywordArray && dataObj._commentKeywordArray.length > 0" class="jdoc-card__keywords">
            <el-tag v-for="keyword in dataObj._commentKeywordArray" :key="keyword" type="warning" size="small" effect="plain">{{ keyword }}</el-tag>
        </div>

        <div class="jdoc-card__foot">{{ dataObj.createTime }} 刷新</div>
    </div>

    <!-- ============================================================================================================== -->
    <!-- 详细信息弹框 -->
    <!-- 示例说明 -->
    <el-dialog class="jdoc-dialog" v-model="commentExampleDialog" title="示例说明" width="90%" center fullscreen>
        <v-md-editor v-model="dataObj.commentExample" mode="preview" ref="editor" @copy-code-success="handleCopyCodeSuccess" />
        <template #footer>
            <span class="jdoc-dialog__foot">
                <el-affix position="bottom" :offset="20">
                    <el-button type="primary" @click="commentExampleDialog = false">我知道了</el-button>
                </el-affix>
            </span>
        </template>
    </el-dialog>

    <!-- 类信息 -->
    <el-dialog class="jdoc-dialog" v-model="classDetailsDialog" title="类信息" width="90%" center>
        <div class="jdoc-md">
            <h3 class="jdoc-md__title">概述</h3>
            <div v-if="dataObj.javaDocClassLite.commentInfo" v-html="dataObj.javaDocClassLite.commentInfo"></div>
            <div v-else class="jdoc-md__none">无</div>

            <h3 class="jdoc-md__title">场景</h3>
            <div v-if="dataObj.javaDocClassLite.commentScene" v-html="dataObj.javaDocClassLite.commentScene"></div>
            <div v-else class="jdoc-md__none">无</div>

            <h3 class="jdoc-md__title">限制</h3>
            <div v-if="dataObj.javaDocClassLite.commentLimit" v-html="dataObj.javaDocClassLite.commentLimit"></div>
            <div v-else class="jdoc-md__none">无</div>

            <h3 class="jdoc-md__title">示例</h3>
            <v-md-editor v-if="dataObj.javaDocClassLite.commentExample" v-model="dataObj.javaDocClassLite.commentExample" mode="preview" ref="editor" @copy-code-success="handleCopyCodeSuccess" />
            <div v-else class="jdoc-md__none">无</div>

            <h3 class="jdoc-md__title">日志</h3>
            <el-table v-if="dataObj.javaDocClassLite.commentLog && dataObj.javaDocClassLite.commentLog.length > 0" :data="dataObj.javaDocClassLite.commentLog" :default-sort="{ prop: 'version', order: 'descending' }" style="width: 100%" border>
                <el-table-column prop="version" label="版本" sortable width="180" />
                <el-table-column prop="time" label="修改时间" sortable width="180" />
                <el-table-column prop="author" label="修改人" width="180" />
                <el-table-column prop="content" label="修改内容" />
            </el-table>
            <div v-else class="jdoc-md__none">无</div>

            <h3 class="jdoc-md__title">关键字</h3>
            <div v-if="dataObj.javaDocClassLite.commentKeywords" v-html="dataObj.javaDocClassLite.commentKeywords"></div>
            <div v-else class="jdoc-md__none">无</div>
        </div>
        <template #footer>
            <span class="jdoc-dialog__foot">
                <el-affix position="bottom" :offset="20">
                    <el-button type="primary" style="width: 300px" @click="classDetailsDialog = false">我知道了</el-button>
                </el-affix>
            </span>
        </template>
    </el-dialog>

    <!-- 方法源码 -->
    <el-dialog class="jdoc-dialog" v-model="sourceCodeDialog" title="方法源码" width="90%" center fullscreen>
        <v-md-editor v-model="sourceCodeText" mode="preview" ref="editor" @copy-code-success="handleCopyCodeSuccess" />
        <template #footer>
            <span class="jdoc-dialog__foot">
                <el-affix position="bottom" :offset="20">
                    <el-button type="primary" style="width: 300px" @click="sourceCodeDialog = false">关闭</el-button>
                </el-affix>
            </span>
        </template>
    </el-dialog>

    <!-- 源文件 -->
    <el-dialog class="jdoc-dialog" v-model="originDocumentDialog" title="源文件" width="90%" center fullscreen>
        <v-md-editor v-model="originalDocumentText" mode="preview" ref="editor" @copy-code-success="handleCopyCodeSuccess" />
        <template #footer>
            <span class="jdoc-dialog__foot">
                <el-affix position="bottom" :offset="20">
                    <el-button type="primary" style="width: 300px" @click="originDocumentDialog = false">关闭</el-button>
                </el-affix>
            </span>
        </template>
    </el-dialog>
</template>

<script>
import { ElMessage } from 'element-plus';
import request from '../../../utils/request.js';
import { copy } from '../../../utils/clipboard.js';
export default {
    props: {
        data: Object
    },
    data() {
        return {
            isLogin: false,
            commentExampleDialog: false,
            classDetailsDialog: false,
            originDocumentDialog: false,
            sourceCodeDialog: false,
            sourceCodeText: '',
            originalDocumentText: '',
            dataObj: {},
            user: { roles: [] },
            helpfulRate: 0
        };
    },
    mounted() {
        this.user.roles = this.$store.state.user.roles;
        if (this.$store.state.user.token == undefined || this.$store.state.user.token == '') {
            this.isLogin = false;
            this.user.roles = [];
        } else {
            this.isLogin = true;
        }

        this.dataObj = this.data;

        // 接口返回的 params / throwses / commentLog 是 json 字符串，统一转成数组后模板才能正确渲染
        this.dataObj.params = this.toArray(this.dataObj.params);
        this.dataObj.throwses = this.toArray(this.dataObj.throwses);
        this.dataObj.commentLog = this.toArray(this.dataObj.commentLog);
        if (this.dataObj.javaDocClassLite) {
            this.dataObj.javaDocClassLite.commentLog = this.toArray(this.dataObj.javaDocClassLite.commentLog);
        }

        // 设置是否public
        if (this.dataObj.qualifier && this.dataObj.qualifier.indexOf('public') > -1) {
            this.dataObj._isPublic = true;
        }

        // 结构化关键字信息
        if (this.dataObj.commentKeywords) {
            this.dataObj._commentKeywordArray = this.dataObj.commentKeywords.replaceAll('，', ',').split(',');
        }

        // 高亮关键字
        if (this.dataObj._highlightKeys && this.dataObj._highlightKeys.length > 0) {
            for (var i = 0; i < this.dataObj._highlightKeys.length; i++) {
                if (this.dataObj.commentInfo) this.dataObj.commentInfo = this.setHighlightKeys(this.dataObj.commentInfo, this.dataObj._highlightKeys[i]);
                if (this.dataObj.commentScene) this.dataObj.commentScene = this.setHighlightKeys(this.dataObj.commentScene, this.dataObj._highlightKeys[i]);
                if (this.dataObj.commentLimit) this.dataObj.commentLimit = this.setHighlightKeys(this.dataObj.commentLimit, this.dataObj._highlightKeys[i]);
                if (this.dataObj.commentKeywords) this.dataObj.commentKeywords = this.setHighlightKeys(this.dataObj.commentKeywords, this.dataObj._highlightKeys[i]);
            }
        }
    },
    methods: {
        helpful() {
            request({
                url: '/openapi/javadoc/helpful',
                method: 'post',
                data: {
                    metaId: this.dataObj.id,
                    classId: this.dataObj.metaType == 'JavaDocClass' ? this.dataObj.id : this.dataObj.classId,
                    projectId: this.dataObj.projectId,
                    helpfulRate: this.helpfulRate
                }
            }).then(res => {
                if (res.code == 0) {
                    ElMessage({
                        message: '感谢您的反馈',
                        type: 'success',
                        duration: 1 * 1000
                    });
                }
            });
        },
        copy(s) {
            copy(s);
            ElMessage({
                message: '复制成功',
                type: 'success',
                duration: 1 * 1000
            });
        },
        // 兼容 数组 / json 字符串 / 空值 三种情况
        toArray(value) {
            if (Array.isArray(value)) return value;
            if (!value) return [];
            if (typeof value === 'string') {
                try {
                    const parsed = JSON.parse(value);
                    return Array.isArray(parsed) ? parsed : [];
                } catch (e) {
                    return [];
                }
            }
            return [];
        },
        setHighlightKeys(text, key, bgColor) {
            var sText = text;
            bgColor = bgColor || 'yellow';
            let color = 'red';
            var sKey = "<span style='background-color: " + bgColor + ';color: ' + color + ";font-weight:bold;'> " + key + ' </span>';
            var regStr = new RegExp(key, 'g');
            sText = sText.replace(regStr, sKey); //替换key
            return sText;
        },
        handleCopyCodeSuccess(code) {
            ElMessage({
                message: '复制成功',
                type: 'success',
                duration: 1 * 1000
            });
        },
        showDialog(type) {
            switch (type) {
                case 'commentExampleDialog':
                    this.commentExampleDialog = true;
                    break;
                case 'classDetailsDialog':
                    // 类详情只在接口返回了类信息时可用
                    if (!this.dataObj.javaDocClassLite) return false;
                    this.classDetailsDialog = true;
                    break;
                case 'sourceCodeDialog':
                    {
                        if (!this.isLogin) {
                            ElMessage({
                                message: '查看方法源码请先登录哦~',
                                type: 'warning',
                                duration: 1 * 1000
                            });
                            return false;
                        }

                        let id = '';
                        let type = '';
                        if (this.dataObj.metaType == 'JavaDocClass') {
                            type = 'class';
                            id = this.dataObj.id;
                        }
                        if (this.dataObj.metaType == 'JavaDocMethod') {
                            type = 'method';
                            id = this.dataObj.id;
                        }
                        request({
                            url: '/javadoc/getSourceCode',
                            method: 'post',
                            data: {
                                id: id,
                                type: type
                            }
                        }).then(res => {
                            if (res.code == 0) {
                                this.sourceCodeText = '```java' + '\r\n' + res.meta.sourceCode + '\r\n' + '```';
                            }
                            this.sourceCodeDialog = true;
                        });
                    }
                    break;
                case 'originDocumentDialog':
                    {
                        if (!this.isLogin) {
                            ElMessage({
                                message: '查看源文件请先登录哦~',
                                type: 'warning',
                                duration: 1 * 1000
                            });
                            return false;
                        }

                        let classId = '';
                        if (this.dataObj.metaType == 'JavaDocClass') classId = this.dataObj.id;
                        if (this.dataObj.metaType == 'JavaDocMethod') classId = this.dataObj.classId;
                        request({
                            url: '/javadoc/getOriginalDocument',
                            method: 'post',
                            data: {
                                classId: classId
                            }
                        }).then(res => {
                            if (res.code == 0) {
                                this.originalDocumentText = '```java' + '\r\n' + res.meta.originalDocument + '\r\n' + '```';
                            }
                            this.originDocumentDialog = true;
                        });
                    }
                    break;
            }
        }
    }
};
</script>

<style>
/* 卡片样式非 scoped：搜索页的帮助演示卡片也复用同一套视觉 */
.jdoc-card {
    padding: 14px 16px;
    margin-bottom: 12px;
    border: 1px solid var(--jdoc-line);
    border-radius: 14px;
    background-color: #fff;
    box-shadow: 0 1px 2px rgba(28, 47, 84, 0.05);
}

.jdoc-card.is-deprecated {
    border-color: #f3d6d6;
    background-color: #fffbfb;
}

.jdoc-card__head {
    display: flex;
    align-items: flex-start;
    gap: 10px;
}

.jdoc-card__kind {
    flex: none;
    width: 44px;
    height: 24px;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 600;
    line-height: 24px;
    text-align: center;
}

.jdoc-card__kind.is-class {
    color: #2f6fed;
    background-color: #eaf1fd;
}

.jdoc-card__kind.is-method {
    color: #b77415;
    background-color: #fdf3e6;
}

.jdoc-card__title {
    display: flex;
    flex: 1 1 auto;
    flex-wrap: wrap;
    align-items: center;
    gap: 6px;
    min-width: 0;
}

.jdoc-card__tag {
    flex: none;
}

.jdoc-card__class {
    font-size: 14px;
    font-weight: 600;
    color: var(--el-color-primary);
    word-break: break-all;
}

/* 只有接口带回了类信息时才可点击查看类详情 */
.jdoc-card__class.is-clickable {
    cursor: pointer;
}

.jdoc-card__class.is-clickable:hover {
    text-decoration: underline;
}

.jdoc-card__dot {
    color: var(--jdoc-muted);
}

.jdoc-card__name {
    font-size: 14px;
    font-weight: 600;
    color: var(--jdoc-text);
    word-break: break-all;
}

.jdoc-card__copy {
    font-size: 15px;
    color: var(--jdoc-muted);
    cursor: pointer;
}

.jdoc-card__copy:hover {
    color: var(--el-color-primary);
}

.jdoc-card__rate {
    --el-rate-height: 16px;
    --el-rate-icon-size: 15px;
    --el-rate-icon-margin: 1px;
}

.jdoc-card__project {
    flex: none;
    max-width: 34%;
    font-size: 12px;
    line-height: 20px;
    color: var(--jdoc-muted);
    text-align: right;
    word-break: break-all;
}

.jdoc-card__brief {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    margin-top: 10px;
}

.jdoc-card__info {
    flex: 1 1 auto;
    min-width: 0;
    font-size: 13px;
    line-height: 20px;
    color: var(--jdoc-text);
}

.jdoc-card__acts {
    display: flex;
    flex: none;
    flex-wrap: wrap;
    gap: 8px;
}

.jdoc-card__line {
    margin-top: 8px;
    font-size: 13px;
    line-height: 20px;
}

.jdoc-card__line--scene {
    color: #1d4ed8;
}

.jdoc-card__line--limit {
    color: #c0392b;
}

.jdoc-card__emoji {
    margin-right: 2px;
}

.jdoc-card__strong {
    font-weight: 600;
}

.jdoc-card__io {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    margin-top: 10px;
}

.jdoc-card__iobox {
    padding: 10px 12px;
    border: 1px dashed #cfd8e6;
    border-radius: 10px;
    font-size: 13px;
    line-height: 20px;
    background-color: #fafcff;
}

.jdoc-card__iocap {
    margin-bottom: 6px;
    font-size: 12px;
    color: var(--jdoc-muted);
}

.jdoc-card__iorow {
    display: flex;
    flex-wrap: wrap;
    align-items: baseline;
    gap: 4px;
    margin: 0 0 4px;
}

.jdoc-card__iorow:last-child {
    margin-bottom: 0;
}

.jdoc-card__colon {
    color: var(--jdoc-muted);
}

.jdoc-card__keywords {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-top: 10px;
}

.jdoc-card__foot {
    margin-top: 10px;
    font-size: 12px;
    color: var(--jdoc-muted);
}

.jdoc-card__log {
    padding: 4px;
    border: 1px solid var(--jdoc-line);
    border-radius: 10px;
}

/* ---------- 弹窗内的小标题 / 空值 ---------- */
.jdoc-md__title {
    margin: 18px 0 8px;
    font-size: 14px;
    font-weight: 600;
    color: var(--jdoc-text);
}

.jdoc-md__title:first-child {
    margin-top: 0;
}

.jdoc-md__none {
    font-size: 13px;
    color: var(--jdoc-muted);
}

.jdoc-dialog__foot {
    display: flex;
    justify-content: center;
}

/* ---------- 小尺寸设备适配 ---------- */
@media (max-width: 768px) {
    .jdoc-card {
        padding: 12px;
        margin-bottom: 10px;
    }

    .jdoc-card__head {
        flex-wrap: wrap;
    }

    /* 工程名移到下一行，避免与类名争抢宽度 */
    .jdoc-card__project {
        flex: 1 1 100%;
        max-width: 100%;
        text-align: left;
    }

    .jdoc-card__brief {
        flex-direction: column;
        gap: 10px;
    }

    .jdoc-card__acts {
        flex: 1 1 auto;
    }

    .jdoc-card__io {
        grid-template-columns: 1fr;
    }
}
</style>
